<template>
  <div class="mnNavbar">
    <div class="layout-logo l">
      <img :src="logo" />
    </div>
    <el-menu :default-active="active" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item  v-for="item in MenuItem" :index="item.link" :key="item.link">
        <span v-html="item.title"></span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>

export default {
  data () {
    return {
      logo: require('@/assets/pcimages/mn_LOGO1.png'),
      value: false,
      MenuItem: [
        {
          name: '1',
          link: '/mnHome',
          title: 'ᠲᠡᠷᠢᠭᠦᠨ <br>ᠨᠢᠭᠤᠷ'
        },
        {
          name: '2',
          link: '/mnSuccessfulCases',
          title: 'ᠠᠮᠵᠢᠯᠳᠠ<br>ᠲᠠᠢ <br> ᠵᠢᠱ᠌ᠢᠶ᠎ᠡ'
        },
        {
          name: '3',
          link: '/mnTechnicalService',
          title: 'ᠮᠡᠷᠭᠡᠵᠢᠯ<br>ᠦᠢᠯᠡᠴᠢᠯᠡᠭᠡ'
        },
        {
          name: '4',
          link: 'https://ime.nmgoyun.com/',
          // link: '/mnDownload',
          title: ' ᠪᠢᠴᠢᠭᠯᠡᠬᠦ<br> ᠠᠷᠭ᠎ᠠ ᠪᠠ<br> ᠲᠢᠭ'
        },
        {
          name: '5',
          link: '/mnAboutUs',
          title: 'ᠪᠢᠳᠡᠨ᠎ᠤ<br> ᠲᠣᠬᠠᠢ'
        },
        {
          name: '6',
          link: '/mnJoinUs',
          title: 'ᠴᠢᠳᠠᠪᠤᠷᠢᠳᠠᠨ<br> ᠡᠯᠰᠡᠬᠦ'
        },
        // {
        //   name: '7',
        //   link: 'https://chat.nmgoyun.com/',
        //   title: 'ᠣᠶᠤᠨ ᠲᠣᠮᠤ<br> ᠵᠠᠭᠪᠤᠷ'
        // },
        {
          name: '8',
          link: 'https://ai.nmgoyun.com/',
          title: 'ᠣᠶᠤᠨ <span>AI</span>'
        },
        {
          name: '9',
          link: '/dashboard',
          title: 'ᠬᠢᠲᠠᠳ<br> ᠬᠡᠪ'
        }
      ],
      active: ''
    }
  },
  mounted () {
    this.active = this.$route.path
  },
  methods: {
    handleSelect (val) {
      if (val.startsWith('/')) {
        this.$router.replace({path: val})
      } else {
        window.open(val, '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.mnNavbar {
  overflow: hidden;
  position: relative;
  background: #fff;
  width: 100%;
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .layout-logo {
    float: left;
  }

  .block{
    flex: 0 0 px2rem(120);
  }
}
</style>



// WEBPACK FOOTER //
// src/layoutMN/components/Navbar.vue